import useAuth from '@/modules/auth/composables/use-auth'
import type { Router, RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import useError from '@/composables/error/useError'

const { authorize, authorized } = useAuth()
const { isClientAxiosError } = useError()

function checkIfPageExists(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
): void {
    if (!to.matched.length) {
        // Route doesn't exists
        return next({
            name: '404',
        })
    }

    return next()
}

async function authRequired(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext)
: Promise<void> {
    if (!to?.meta?.authRequired) {
        return next()
    }

    if (to?.meta?.authRequired && authorized.value) {
        // User is authorized
        return next()
    }

    if (to?.meta?.authRequired && !authorized.value) {
        try {
            // Trying to log in via cookies
            await authorize()
            return next()
        } catch (error) {
            if (isClientAxiosError(error)) {
                // Failed to log in with cookie token
                return next({
                    name: 'auth-sign-in',
                })
            }

            throw error
        }
    }

    return next({
        name: 'auth-sign-in',
    })
}

// async function checkFeatureFlag(
//     to: RouteLocationNormalized,
//     from: RouteLocationNormalized,
//     next: NavigationGuardNext
// ) {
//     const featureFlagsMeta = to.meta?.featureFlags

//     if (!featureFlagsMeta?.length) {
//         return next()
//     }

//     if (!featureFlagsMeta.every(t => useFlag(t).value)) {
//         return next({ name: 'dashboard' })
//     }

//     return next()
// }

function addGuardsToRouter(router: Router) {
    router.beforeEach(checkIfPageExists)
    router.beforeEach(authRequired)
    // router.beforeEach(checkFeatureFlag)
}

export default addGuardsToRouter
